<template lang="pug">
keep-alive
  .res
    .title {{$t('reservation.res3.title')}}
    .content
      fam-picker(@addAdult="onAddAdult" @addChild="onAddChild" @faceVerify="onFaceVerify")
    .bot
      //.btn-next(@click="onNext") {{$t('btn.nextStep')}}
      .next(v-if="!verifyComplete" @click="onNext") 点击此处跳过人脸核验
      FamPickerInstruction(:verifyComplete="verifyComplete")
      primary-btn(type="nextStep" @clicked="onNext" :active="verifyComplete")

      
  
</template>
<script>
import AlipayService from '@/services/AlipayService'
import FamPicker from '@/components/res/FamPicker'
import { mapState, mapMutations, mapActions } from 'vuex'
import FamPickerInstruction from '@/components/res/FamPickerInstruction'
import PrimaryBtn from '@/components/wedgits/PrimaryBtn'
import { getUniqueId } from '@/api/index'
export default {
  name: 'Res3',
  components: { PrimaryBtn, FamPickerInstruction, FamPicker },
  props: {},
  data() {
    return {
      unique_id: null,
    }
  },
  created() {
    this.fetchUserInfo()
    this.fecthUniqueId()
  },
  watch: {
    $route(val) {
      console.log(val)
      if (val.path.indexOf('/res3') === -1) return
      this.fetchUserInfo()
    },
  },
  computed: {
    ...mapState('app', ['user']),
    verifyComplete() {
      for (let u of this.user.famUsers) {
        if (u.vspFaceStatus !== 1 && u.id == this.user.id) return false
      }
      return true
    },
  },
  methods: {
    ...mapMutations('app', ['setRouterBack', 'setRouterLast', 'setPending']),
    ...mapActions('app', ['GetUser']),
    onNext() {
      this.setRouterBack('/reservation/res3')
      this.$router.replace('/reservation/res4')
    },
    onAddAdult() {
      setTimeout(() => {
        this.setRouterBack('/reservation/res3')
        this.$router.replace('/reservation/addAdult')
      }, 0)
    },
    onAddChild() {
      console.log('add child')
      AlipayService.sendEvent(AlipayService.Events.ADD_CHILD_REQUEST)
    },
    onFaceVerify(id) {
      console.log('face verify')
      AlipayService.sendEvent(AlipayService.Events.FACE_VERIFY_REQUEST, {
        uniqueId: this.unique_id,
      })
    },
    fetchUserInfo() {
      this.setPending(true)
      this.GetUser(this.user.id)
        .then(() => {
          this.setPending(false)
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
        })
    },
    fecthUniqueId() {
      let data = new FormData()
        data.append('userId', this.user.id)
      getUniqueId(data).then((res) => {
        console.log(res)
        this.unique_id = res.unique_id
        console.log(res.unique_id)
      })
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
@import "src/styles/res.sass"
.bot
  .next
    font-size: pxToRem(36)
    width: 100%
    margin-bottom: pxToRem(24)
    text-decoration: underline
  .primary-btn
    top: 0
    margin-top:  pxToRem(74)
    margin-bottom:  pxToRem(98)
</style>
